<template>
  <div class="cal__body_header">
        <AppBodyHeaderField v-bind:idCategory="1" name="Conseil" />
        <div class="cal__bloc_header_separator cal__bloc_header_separator1"></div>
        <AppBodyHeaderField v-bind:idCategory="2" name="Création" />
        <div class="cal__bloc_header_separator cal__bloc_header_separator2"></div>
        <AppBodyHeaderField v-bind:idCategory="3" name="Technique / Dev" />
        <div class="cal__bloc_header_separator cal__bloc_header_separator3"></div>
        <div class="cal__bloc_header cal__bloc--active cal__font_bree">
            <span class="cal__bloc_number">=</span>
            <span class="cal__bloc_title">Budget</span>
        </div>
    </div>
</template>

<script>
import AppBodyHeaderField from './AppBodyHeaderField.vue'

export default {
  name: 'AppBodyHeader',
  components: {
    AppBodyHeaderField
  }
}
</script>
